// extracted by mini-css-extract-plugin
module.exports = {"btn":"Button_btn__VSU8v","btn_gradient":"Button_btn_gradient__chASW","link":"Button_link__Vpskr"};